/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "adamdelldoor",
            "endpoint": "https://xrti2ae1uf.execute-api.us-west-2.amazonaws.com/semain",
            "region": "us-west-2"
        },
        {
            "name": "braintreeRest",
            "endpoint": "https://0roi1esj6c.execute-api.us-west-2.amazonaws.com/semain",
            "region": "us-west-2"
        },
        {
            "name": "stripe",
            "endpoint": "https://h5soh3fgq4.execute-api.us-west-2.amazonaws.com/semain",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:0c000850-1469-4957-b893-b11f36232d15",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_43riDWR8l",
    "aws_user_pools_web_client_id": "4gcurbiumrkq1ms7n1asa4ve2b",
    "oauth": {
        "domain": "sharedearth-auth-semain.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://dev.ocupop.com.ngrok.io/,https://develop.d3txw6ym8jbhy9.amplifyapp.com/,https://main.d3txw6ym8jbhy9.amplifyapp.com/,https://sharedearth.com/",
        "redirectSignOut": "http://localhost:3000/,https://dev.ocupop.com.ngrok.io/,https://develop.d3txw6ym8jbhy9.amplifyapp.com/,https://main.d3txw6ym8jbhy9.amplifyapp.com/,https://sharedearth.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "sharedearthbucket143407-semain",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
